import { FUND_INVESTMENTS_TITLE_SINGULAR } from 'pages/FundInvestments/common/constants';

export const BULK_ACTIONS = 'Bulk Actions';
export const EDIT_COMPANY = 'Edit Company';
export const EDIT_COMMON_PROFILE = 'Edit Common Profile';
export const EDIT_FUND_INVESTMENT = `Edit ${FUND_INVESTMENTS_TITLE_SINGULAR}`;
export const EXCEL_EXPORT = 'Excel Export';
export const PDF_EXPORT = 'PDF Export';
export const SAVE = 'Save';

export const COMPANY_ACTION_QUERY_PARAM = 'company-action';
export const COMPANY_PAGE_ACTIONS = {
  ADD_ALLOCATION_SCENARIO: 'add-allocation-scenario',
  ADD_BACKSOLVE_APPROACH: 'add-backsolve-approach',
  ADD_CALIBRATION: 'add-calibration',
  ADD_DCF_APPROACH: 'add-dcf-approach',
  ADD_EXTERNAL_VALUATION_APPROACH: 'add-external-valuation-approach',
  ADD_FUND_OWNERSHIP: 'add-fund-ownership',
  ADD_FUTURE_EXIT_APPROACH: 'add-future-exit-approach',
  ADD_PUBLIC_COMPS_APPROACH: 'add-public-comps-approach',
  ADD_RANGE_SENSITIVITY: 'add-range-sensitivity',
  ADD_SECURITY: 'add-security',
  ADD_SECONDARY_TRANSACTIONS_APPROACH: 'add-secondary-transactions-approach',
  ADD_SPECIFIED_SHARE_VALUES_APPROACH: 'add-specified-share-values-approach',
  ADD_TRANSACTION_COMPS_APPROACH: 'add-transaction-comps-approach',
  CREATE_PRO_FORMA_CAP_TABLE: 'create-pro-forma-cap-table',
} as const;

export type CompanyPageAction = (typeof COMPANY_PAGE_ACTIONS)[keyof typeof COMPANY_PAGE_ACTIONS];

export const isCompanyPageAction = (value: string | null): value is CompanyPageAction =>
  Object.values(COMPANY_PAGE_ACTIONS).some(action => action === value);

export const FIRM_ACTION_QUERY_PARAM = 'firm-action';
export const FIRM_PAGE_ACTIONS = {
  BULK_ACTIONS: 'bulk-actions',
  EXCEL_EXPORT: 'excel-export',
  PDF_EXPORT: 'pdf-export',
} as const;

export type FirmPageAction = (typeof FIRM_PAGE_ACTIONS)[keyof typeof FIRM_PAGE_ACTIONS];

export const isFirmPageAction = (value: string | null): value is FirmPageAction =>
  Object.values(FIRM_PAGE_ACTIONS).some(action => action === value);
